<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="formSubmitting"
  [isDisabled]="formInvalid">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <app-property-add-address [parent]="data.parent" [withAddressSearch]="data.withAddressSearch"
      (propertyCreated)="onPropertyCreated($event)"></app-property-add-address>
  </div>
